import React from "react";
import {
  Edit,
  SimpleForm,
  TextInput,
  ImageInput,
  ReferenceInput,
  SelectInput,
  required,
  BooleanInput,
  ImageField
} from "react-admin";
import { FormToolbar } from "../../common/FormToolbar";
import { useStyles } from "../../formStyles";

export const LookupEdit = (props) => {
  const classes = useStyles({});
  let propsObj = { ...props };
  if (propsObj.permissions) {
    let resourcename = `/${props.resource}`;
    let myPermissions = propsObj.permissions.filter(item => item.NavigateUrl.toLowerCase().trim() == resourcename);
    if (myPermissions.length > 0) {
      let p = myPermissions[0];
      propsObj.hasList = (p.View == 1) ? true : false;
      propsObj.hasShow = (p.View == 1) ? true : false;
      propsObj.hasEdit = (p.Edit == 1) ? true : false;
      propsObj.hasDelete = (p.Delete == 1) ? true : false;
      propsObj.hasCreate = (p.Create == 1) ? true : false;
      propsObj.hasExport = (p.Export == 1) ? true : false;
    }
  }

  return (
    <Edit  {...propsObj}>
      <SimpleForm toolbar={<FormToolbar {...props} />} variant="outlined">
        <TextInput source="code" validate={[required()]} fullWidth={true} formClassName={classes.one_4_input} disabled />
        <TextInput source="type" validate={[required()]} fullWidth={true} formClassName={classes.two_4_input} disabled />
        <TextInput source="name" validate={[required()]} fullWidth={true} formClassName={classes.three_4_input} disabled />
        <TextInput source="value" validate={[required()]} fullWidth={true} formClassName={classes.last_4_input} />
        <TextInput source="value1" fullWidth={true} formClassName={classes.one_4_input} />
        <TextInput source="narration"  disabled fullWidth={true} formClassName={classes.two_4_input} />
      </SimpleForm>
    </Edit>
  );
};
